
export function sortObjToStr (sorting) {
  const sortDirection = sorting.direction === 'asc' ? '' : '-';
  return `${sortDirection}${sorting.name}`;
}

export function convertSorting (sorting, joinSymbol = ' ') {
  if (Array.isArray(sorting)) {
    return sorting.map(i => sortObjToStr(i)).join(joinSymbol);
  }
  return sortObjToStr(sorting);
}
